<template>
    <div v-loading="loading">
        <zm-row>
            <zm-button size="small" @click="showAll()" type="primary" class="btn-in-line" plain>show all</zm-button>
            <zm-button size="small" @click="showDeleteAgent()" type="danger" class="btn-in-line" plain>delete by filter</zm-button>
            <zm-button size="small" @click="deleteAgent()" type="danger" class="btn-in-line" plain v-if="ids.length">delete</zm-button>
            <zm-input size="small" placeholder="appName" v-model.trim="appName" @keyup.enter.native="doSearch()" class="agent-search">
                <zm-input size="small" slot="prepend" class="search-ip" v-model.trim="ip" placeholder="ip" @keyup.enter.native="doSearch()"></zm-input>
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="doSearch()"></zm-button>
            </zm-input>
            <zm-input size="small" placeholder="requestIp" v-model.trim="requestIp" @keyup.enter.native="doSearch()" class="agent-search-requestIp">></zm-input>
            <zm-input size="small" placeholder="version" v-model.trim="version" @keyup.enter.native="doSearch()" class="agent-search-version">></zm-input>
            <!-- <zm-input size="small" placeholder="search" v-model.trim="search" class="search-input" @keyup.enter.native="doSearch()">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="doSearch()"></zm-button>
            </zm-input>
            <zm-select size="small" v-model="select" class="search-select" @change="changeSearchType">
                <zm-option label="ip" value="ip"></zm-option>
                <zm-option label="appName" value="appName"></zm-option>
                <zm-option label="requestIp" value="requestIp"></zm-option>
            </zm-select> -->
        </zm-row>
        <zm-table :data="list" border @sort-change="onSort" @selection-change="handleSelectionChange" :init-displayed-column="initDisplayedColumn">
            <zm-table-column prop="selection" type="selection" width="55" v-if="hasPermission"></zm-table-column>
            <zm-table-column prop="appName" label="appName"></zm-table-column>
            <zm-table-column prop="agentType" label="agentType"></zm-table-column>
            <zm-table-column prop="requestIp" label="requestIp"></zm-table-column>
            <zm-table-column prop="ip" label="ip"></zm-table-column>
            <zm-table-column prop="mac" label="mac"></zm-table-column>
            <zm-table-column prop="port" label="port"></zm-table-column>
            <zm-table-column prop="clientStatus" label="clientStatus" sortable></zm-table-column>
            <zm-table-column prop="version" label="version"></zm-table-column>
            <zm-table-column prop="channelInfoMap" label="channelInfo">
                <template slot-scope="scope">
                    <zm-popover
                        placement="left-start"
                        trigger="click">
                        <div>
                            <p v-for="(item, index) in scope.row.channelInfoMap" :key="index">{{ item.ip }} - {{ item.username }}</p>
                        </div>
                        <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-eyes" slot="reference"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column prop="connectedChannels" label="connectedChannels" width="180px">
                <template slot-scope="scope">
                    <zm-popover v-if="scope.row.connectedChannels"
                        placement="left-start"
                        trigger="click">
                        <div>
                            <p v-for="(item, index) in Object.keys(scope.row.connectedChannels)" :key="index">{{ item }} : {{ scope.row.connectedChannels[item] }}</p>
                        </div>
                        <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-eyes" slot="reference"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column prop="appConsumerGroups" label="appConsumerGroups" width="180px">
                <template slot-scope="scope">
                    <zm-popover v-if="scope.row.appConsumerGroups"
                        placement="left-start"
                        trigger="click">
                        <div>
                            <li v-for="(item, index) in Object.keys(scope.row.appConsumerGroups)" :key="index">
                                {{ item }}
                                <ul><li v-for="i in Object.keys(scope.row.appConsumerGroups[item])" :key="i">{{i}}
                                    <ol><li v-for="(j, jIndex) in scope.row.appConsumerGroups[item][i]" :key="jIndex">{{j}}</li></ol>
                                </li></ul>
                            </li>
                        </div>
                        <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-eyes" slot="reference"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column prop="updateTime" label="updateTime" :formatter="setTime"></zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="paginationChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                layout="sizes, total, prev, pager, next"
                :total="pageable.total">
            </zm-pagination>
        </div>
        <zm-dialog title="Delete Agents By Filters" :visible.sync="visible">
            <zm-form :model="form" ref="form" :rules="rules" label-width="160px">
                <zm-form-item label="appName" prop="appName">
                    <div slot="label">
                        <tip label="App Name" id="agent-appName"></tip>
                    </div>
                    <zm-input v-model="form.appName"></zm-input>
                </zm-form-item>
                <zm-form-item label="date" prop="date">
                    <div slot="label">
                        <tip label="Date Before" id="agent-date"></tip>
                    </div>
                    <zm-date-picker v-model="form.date" type="datetime" value-format="timestamp" size="small"></zm-date-picker>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="danger" @click="batchDelete()" :loading="loading">Delete</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listAgent, searchAgent, deleteAgent, batchDeleteAgent } from '../../api/agent'
import tip from 'components/ToolTip/index'
export default {
    name: 'agent',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'agent',
                props: ['selection', 'appName', 'ip', 'mac', 'port', 'clientStatus', 'version', 'channelInfoMap', 'connectedChannels', 'appConsumerGroups', 'updateTime']
            },
            list: [],
            ids: [],
            isSearch: false,
            ip: '',
            appName: '',
            requestIp: '',
            version: '',
            select: 'ip',
            search: '',
            role: localStorage.role,
            loading: false,
            form: {
                appName: '',
                date: ''
            },
            visible: false,
            rules: {
                appName: [
                    { required: true, message: 'please enter appName', trigger: 'blur' }
                ],
                date: [
                    { required: true, message: 'please enter date', trigger: 'blur' }
                ]
            },
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.ip = JSON.parse(localStorage.params).ip
            this.appName = JSON.parse(localStorage.params).appName
            this.requestIp = JSON.parse(localStorage.params).requestIp
            this.version = JSON.parse(localStorage.params).version
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        if (this.ip || this.appName || this.requestIp || this.version) {
            this.fetchSearch()
        } else {
            this.fetchData()
        }
    },
    watch: {
        ip () {
            this.setURL()
        },
        appName () {
            this.setURL()
        },
        requestIp () {
            this.setURL()
        },
        version () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        changeSearchType (val) {
            this.ip = ''
            this.appName = ''
            this.requestIp = ''
            this.version = ''
            this.search = ''
        },
        setURL () {
            const { ip, appName, requestIp, version } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, ip, appName, requestIp, version, page, size }
            localStorage.params = JSON.stringify(data)
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        handleSelectionChange (val) {
            this.ids = []
            val.map(item => {
                this.ids.push(item.id)
            })
        },
        fetchData () {
            this.loading = true
            this.isSearch = false
            listAgent(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, total } = response
                this.list = content
                this.pageable.total = total
                // this.pageable.page = page + 1
                // this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchSearch () {
            this.isSearch = true
            // this[this.select] = this.search
            this.loading = true
            searchAgent(this.ip, this.appName, this.requestIp, this.version, this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, total } = response
                this.list = content
                this.pageable.total = total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showDeleteAgent () {
            this.form.appName = ''
            this.form.date = ''
            this.visible = true
        },
        batchDelete () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('This will delete the agents. Continue?', 'Warning', {
                        confirmButtonText: 'Delete',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        batchDeleteAgent(this.form).then(response => {
                            this.$message({
                                message: 'Delete success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.loading = false
                            this.fetchData()
                        }).catch(() => {
                            this.$message({
                                message: 'Delete error!',
                                type: 'error'
                            })
                            this.loading = false
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        })
                    })
                }
            })
        },
        deleteAgent () {
            this.loading = true
            this.$confirm('This will delete the agents. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteAgent(this.ids).then(response => {
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                    this.loading = false
                    this.fetchData()
                }).catch(() => {
                    this.$message({
                        message: 'Delete error!',
                        type: 'error'
                    })
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return descending ? -1 : 1
            } else if (a[prop] < b[prop]) {
                return descending ? 1 : -1
            } else {
                return 0
            }
            })
        },
        doSearch () {
            if (this.ip || this.requestIp || this.appName || this.version) {
                this.pageable.page = 1
                this.fetchSearch()
            } else {
                this.fetchData()
            }
        },
        showAll () {
            this.pageable.page = 1
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.pageable.page = 1
            this.paginationChange()
        },
        paginationChange () {
            if (this.isSearch) {
                this.fetchSearch()
            } else {
                this.fetchData()
            }
        }
    }
}
</script>
<style>
.zm-popover {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.btn-in-line {
    margin: 10px;
}
.agent-search-requestIp {
    float: right;
    margin: 10px 0;
    width: 150px;
}
.agent-search-requestIp.zm-input .zm-input__inner {
    border-radius: 0;
}
.agent-search-version {
    float: right;
    margin: 10px 0;
    width: 150px;
}
.agent-search-version.zm-input .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.agent-search.zm-input .zm-input__inner {
    border-radius: 0;
}
.agent-search {
    float: right;
    margin: 10px 10px 10px 0;
    width: 350px;
}
.point {
    height: 15px;
    margin-top: 8px;
}
.zm-input-group__prepend .zm-input {
    width: 150px;
}
.agent-search .zm-input-group__prepend {
    padding: 0;
}
.search-ip .zm-input__inner {
    border-radius: 8px 0 0 8px;
    margin: -1px 0 -1px -1px;
    width: 152px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.search-select {
    float: right;
    margin: 10px 0;
    width: 100px;
}
</style>
